import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Circle } from '@mui/icons-material';
import { Avatar, Box, Chip, lighten, Tooltip, useTheme } from '@mui/material';
import { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { OprionsForModel, PositionPointColor, titleColorPoint, } from '../model-view/models/types';
import { useHelpPopupWithRef } from 'shared/hooks/ui/help-popup/help-popup-ref';
import { ColorSelection } from 'console/tabs/graphs/components/color-selection';
import { getPointVehiclePosition, isTooDarkVehicleColor, } from '../model-view/models/utils';
import { useBuyDesignPackage, useDesignPackage } from 'console/shared/hooks/helpers';
export const ColorChangePoint = memo(function ColorChangePoint(props) {
    const options = OprionsForModel(props.model);
    const allow_design_package = props.demo ? true : useDesignPackage();
    return (_jsx(_Fragment, { children: options.map((option) => (_jsx(ColorChangePointItem, { option: option, allow_design_package: allow_design_package, ...props }, `${props.model}_${option}`))) }));
});
export const ColorChangePointItem = memo(function ColorChangePointItem(props) {
    const { color, option, model, is_mirrored, allow_design_package, onChangeColor } = props;
    const [select_color, setSelectColor] = useState(color?.[option] ?? null);
    const [HelpPopup, ref, open, close] = useHelpPopupWithRef();
    const BuyDesignPackage = useBuyDesignPackage(close);
    const position = PositionPointColor(model);
    const element = position[option];
    const theme = useTheme();
    const isTooDark = isTooDarkVehicleColor(theme, select_color);
    const chip_color = isTooDark ? '#fff' : '#333';
    const positionLeft = useMemo(() => getPointVehiclePosition(element.left, is_mirrored), [element, is_mirrored]);
    const positionTop = useMemo(() => getPointVehiclePosition(element.top, is_mirrored), [element, is_mirrored]);
    useEffect(() => {
        onChangeColor({ ...color, [option]: select_color });
    }, [HelpPopup]);
    const onChange = useCallback((new_value) => {
        setSelectColor(new_value.hex);
    }, [color, setSelectColor]);
    const handleToggle = useCallback(() => {
        if (HelpPopup != null) {
            close();
        }
        else {
            open();
        }
    }, [HelpPopup, close, open]);
    const setAutoColor = useCallback(() => {
        setSelectColor(null);
        close();
    }, [onChangeColor, close]);
    return (_jsxs(Box, { ref: ref, children: [_jsx(Tooltip, { title: titleColorPoint(option), children: _jsx(Box, { position: "absolute", display: element.top == 'none' ? 'none' : 'flex', zIndex: 100, alignItems: "center", top: `${positionTop}%`, left: `${positionLeft}%`, columnGap: 0.5, sx: {
                        transform: 'translate(-50%, -50%)',
                    }, children: _jsx(Chip, { label: _jsx(Avatar, { style: {
                                backgroundColor: select_color && allow_design_package
                                    ? select_color
                                    : undefined,
                            }, sx: {
                                width: 18,
                                height: 18,
                                border: `2px solid ${chip_color}`,
                            }, children: _jsx(Circle, { sx: {
                                    color: select_color && allow_design_package
                                        ? lighten(select_color, 0.5)
                                        : 'grey',
                                } }) }), variant: "outlined", sx: {
                            border: 'none',
                        }, onClick: open }) }) }), _jsx(HelpPopup, { children: allow_design_package ? (_jsx(ColorSelection, { color: select_color ?? '', onChange: onChange, setAuto: setAutoColor, Close: handleToggle })) : (BuyDesignPackage) })] }));
});
